import React from 'react'
import { injectIntl } from 'react-intl'
import { Button, Modal } from 'antd'

const RemoveModal = ({
  visible,
  title,
  description,
  onSubmit,
  onCancel,
  loading,
  intl: { formatMessage },
}) => {
  return (
    <Modal title={title} visible={visible} onCancel={onCancel} footer={null}>
      <div className="font-size-16">{description}</div>
      <div className="text-right">
        <Button size="large" type="primary" danger onClick={onSubmit} loading={loading}>
          {formatMessage({ id: 'action.remove' })}
        </Button>
      </div>
    </Modal>
  )
}

export default injectIntl(RemoveModal)
